const TENANT_KEYS = [
  "tenant_id",
  "tenant_name",
  "tenant_slug",
  "tenant_logo_url",
  "tenant_primary_color",
  "tenant_settings",
];

export function persistTenant(tenant) {
  if (!tenant) {
    clearTenantStorage();
    return;
  }

  localStorage.setItem("tenant_id", String(tenant.id ?? ""));
  localStorage.setItem("tenant_name", tenant.name ?? "");
  localStorage.setItem("tenant_slug", tenant.slug ?? "");
  localStorage.setItem(
    "tenant_logo_url",
    tenant.logo_url != null ? String(tenant.logo_url) : "",
  );
  localStorage.setItem(
    "tenant_primary_color",
    tenant.primary_color != null ? String(tenant.primary_color) : "",
  );
  localStorage.setItem(
    "tenant_settings",
    JSON.stringify(tenant.settings ?? {}),
  );
}

export function readTenantFromStorage() {
  const id = localStorage.getItem("tenant_id");
  if (!id) return null;

  let settings = {};
  try {
    settings = JSON.parse(localStorage.getItem("tenant_settings") || "{}");
  } catch {
    settings = {};
  }

  const logoUrl = localStorage.getItem("tenant_logo_url");
  const primaryColor = localStorage.getItem("tenant_primary_color");

  return {
    id: Number(id),
    name: localStorage.getItem("tenant_name") || "",
    slug: localStorage.getItem("tenant_slug") || "",
    logo_url: logoUrl || null,
    primary_color: primaryColor || null,
    settings,
  };
}

export function clearTenantStorage() {
  TENANT_KEYS.forEach((key) => localStorage.removeItem(key));
}
